export enum PageFocusStatus {
  Active = 'ACTIVE_TAB',
  Inactive = 'INACTIVE_TAB',
  Idle = 'IDLE_TAB',
}

export enum FrontendErrorType {
  RENDER = 'FRONTEND-RENDER-ERROR',
  CONSOLE = 'FRONTEND-CONSOLE-ERROR',
}
